import { map, pick, without } from 'lodash';
import { isMoment } from 'moment';
import signatyreTypes from 'constants/SignatureTypes';

const titles = {
  inn: 'ИНН',
  owner: 'Владелец сертификата',
  snils: 'СНИЛС',
  startDate: 'Действителен с',
  endDate: 'Действителен по',
  serialNumber: 'Серийный номер',
  issuer: 'Издатель сертификата',
  email: 'Адрес электронной почты',
};
const certificateInfoKeys = [
  'inn',
  'owner',
  'snils',
  'startDate',
  'endDate',
  'serialNumber',
  'issuer',
  'email',
];

const certTypeMap = {
  [signatyreTypes.DSS]: certificateInfoKeys,
  [signatyreTypes.QES]: without(certificateInfoKeys, 'snils', 'issuer'),
  [signatyreTypes.ITEX]: certificateInfoKeys,
};

export default function getCertificateInfoFields(certInfo, signType) {
  return map(pick(certInfo, certTypeMap[signType]), (value, field) => ({
    title: titles[field],
    value: getValue(value),
  })).filter((field) => field.value);
}

function getValue(value) {
  if (isMoment(value)) {
    return value.defaultFullFormat();
  } else {
    return value || null;
  }
}
